import { menus } from "../lib/menus.js";

const CheckIcon = ({ checked }) => {
    if (checked) {
        return (
            <span className="flex items-center justify-center w-5 h-5 bg-white rounded-full">
                <svg className="w-3.5 h-3.5 text-blue-600" fill="none" viewBox="0 0 24 24" stroke="currentColor" strokeWidth={3}>
                    <path strokeLinecap="round" strokeLinejoin="round" d="M4.5 12.75l6 6 9-13.5" />
                </svg>
            </span>
        );
    }
    return <span className="w-5 h-5 bg-white border-2 border-gray-300 rounded-full" />;
};

const SelectableChip = ({ label, isSelected, onClick }) => {
    return (
        <button
            onClick={onClick}
            className={`
                flex items-center gap-1 px-3 py-2 rounded-full text-sm font-medium transition-colors duration-300
                ${isSelected 
                ? 'text-white bg-blue-600 hover:bg-blue-700' 
                : 'bg-gray-200/60 hover:bg-gray-200 dark:bg-zinc-700 dark:hover:bg-zinc-600/30'
                }
            `}
        >
            <CheckIcon checked={isSelected} />
            <span>{label}</span>
        </button>
    );
};

const SelectGroup = ({ group, isFilterOpen, toggleFilter, activeFilters }) => {
    return (
        <div className={`
            flex flex-col gap-2 bg-white dark:bg-zinc-800 first:border-0 
            ${isFilterOpen ? 'rounded-none border-t-[1px] border-gray-200 dark:border-gray-500' : 'lg:rounded-2xl'}
        `}>
            <h3 className="text-lg pt-4 pb-2 px-4 font-bold text-gray-600 dark:text-gray-200">{group.label}</h3>
            <div className="flex flex-row flex-wrap gap-2 sm:gap-3 pb-4 px-4 text-gray-600 dark:text-gray-200">
                {group.options.map((option) => (
                    <SelectableChip
                        key={option.value}
                        label={option.name}
                        isSelected={activeFilters[group.key]?.includes(option.value)}
                        onClick={() => toggleFilter(group.key, option.value)}
                    />
                ))}
            </div>
        </div>
    );
};

export const SelectPanel = ({ isFilterOpen, toggleFilter, activeFilters }) => {
    return (
        <>
            {menus.map((group) => (
                <SelectGroup key={group.key} group={group} isFilterOpen={isFilterOpen} toggleFilter={toggleFilter} activeFilters={activeFilters} />
            ))}
        </>
    );
};